import { clone } from 'ramda';
export const initialState = {
  header: {
    approvalTypeId: null,
    siteId: null,
    fourEyesPrinciple: false,
    withNominalApproval: false,
    saving: false,
    changed: false
  },  
  approvalTypeLevels: []
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'OnApprovalTypeAdded':
      return onApprovalTypeAdded(state, action);
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state, action);
    case 'OnDelete':
      return onDelete(state, action);
    case 'OnReasonChanged':
      return onReasonChanged(state, action);
    case 'OnDeleteReason':
      return onDeleteReason(state, action);
    case 'OnAddReason':
      return onAddReason(state, action);
    case 'OnBeforeSaved':
      return onBeforeSave(state, action);
    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { approvalType } = action;
  return {
    ...state,
    header: {
      ...state.header,
      approvalTypeId: approvalType.approvalTypeId,
      approvalTypeCode: approvalType.approvalTypeCode,
      approvalTypeName: approvalType.approvalTypeName,
      fourEyesPrinciple: approvalType.fourEyesPrinciple,
      withNominalApproval: approvalType.withNominalApproval,
      decisionBehaviorId: approvalType.decisionBehaviorId,
      siteId: approvalType.siteId,
      changed: false
    },
    approvalTypeLevels: approvalType.approvalTypeLevels.map(item => {
      return { ...item, changed: false };
    }),
    approvalTypeDecisionReasons: [...approvalType.approvalTypeDecisionReasons]
  };
};

const onDelete = (state, action) => {
  const { index } = action;
  const newCollection = [...state.approvalTypeLevels];
  newCollection.splice(index, 1);

  return {
    ...state,
    header: { ...state.header, changed: false },
    approvalTypeLevels: newCollection
  };
};

const onApprovalTypeAdded = (state, action) => {
  return {
    ...state,
    header: {
      ...state.header,
      approvalTypeId: null,
      siteId: null,
      approvalTypeCode: '',
      approvalTypeName: '',
      fourEyesPrinciple: false,
      withNominalApproval: false,
      decisionBehaviorId: action.behaviorWithoutReasonId,
      changed: false
    },
    approvalTypeLevels: [],
    approvalTypeDecisionReasons: []
  };
};

const onHeaderPropertyChanged = (state, action) => {
  const { propertyName, value } = action;
  return {
    ...state,
    header: {
      ...state.header,
      [propertyName]: value,
      changed: true
    }
  };
};

function onBeforeSave(state, _){
  return {
    ...state,
    header: {
      ...state.header,
      saving: true
    }
  };
}

function onHeaderSaved(state, action) {
  const newReasons = action.reasons ? [...action.reasons] : [];
  return {
    ...state,
    header: {
      ...state.header,
      changed: false,
      saving: false
    },
    approvalTypeDecisionReasons: newReasons
  };
}

const onAddReason = (state, _action) => {
  const newReasons = [...state.approvalTypeDecisionReasons];
  newReasons.push({
    decisionReasonId: null,
    approvalTypeId: state.header.approvalTypeId,
    reason: ''
  });

  return {
    ...state,
    header: { ...state.header, changed: true },
    approvalTypeDecisionReasons: newReasons
  };
};

const onDeleteReason = (state, action) => {
  const { index } = action;
  const newReasons = [...state.approvalTypeDecisionReasons];
  newReasons.splice(index, 1);

  return {
    ...state,
    header: { ...state.header, changed: true },
    approvalTypeDecisionReasons: newReasons
  };
};

const onReasonChanged = (state, action) => {
  const { index, value } = action;
  const newReasons = clone(state.approvalTypeDecisionReasons);
  newReasons[index].reason = value;
  return {
    ...state,
    header: { ...state.header, changed: true },
    approvalTypeDecisionReasons: newReasons
  };
};
